// Diese Datei enthält alle Navigationselemente für die Anwendung

import { entries } from "lodash";

// Hauptnavigation für Superadmins
export const superAdminNavigation = [
  {
    id: 'admin-dashboard',
    title: 'Dashboard',
    path: '/admin/dashboard',
    icon: 'fas fa-tachometer-alt',
    superAdminOnly: true
  },
  {
    id: 'companies',
    title: 'Firmen',
    icon: 'fas fa-building',
    path: '/companies',
    superAdminOnly: true
  },
  // {
  //   id: 'analysis',
  //   title: 'Statistiken',
  //   icon: 'fas fa-chart-line',
  //   path: '/analysis',
  //   superAdminOnly: true
  // }
];

// Hauptnavigation für Firmenbenutzer
export const firmNavigation = [
  {
    id: 'company-dashboard',
    title: 'Dashboard',
    path: '/company/dashboard',
    icon: 'fas fa-chart-line'
  },
  {
    id: 'tests',
    title: 'Tests',
    icon: 'fas fa-clipboard-check',
    path: '/tests'
  },
  {
    id: 'question-groups',
    title: 'Fragengruppen',
    icon: 'fas fa-layer-group',
    path: '/question-groups'
  },
  {
    id: 'applicants',
    title: 'Bewerber',
    icon: 'fas fa-users',
    path: '/applicants'
  },
  {
    id: 'entries',
    title: 'Einträge',
    icon: 'fas fa-file-alt',
    path: '/entries'
  }
];

// Benutzer Navigation (für alle Benutzer)
export const userNavigation = [
  {
    id: 'profile',
    title: 'Profil',
    icon: 'fas fa-user-cog',
    path: '/profile'
  },
  {
    id: 'settings',
    title: 'Einstellungen',
    icon: 'fas fa-cog',
    path: '/settings',
    hideForSuperAdmin: true
  },
  {
    id: 'logout',
    title: 'Abmelden',
    icon: 'fas fa-sign-out-alt',
    path: null,
    action: true
  }
];
export const userDropdownMenu = [
  {
    id: 'profile',
    title: 'Profil',
    icon: 'fas fa-user',
    path: '/profile'
  },
  {
    id: 'logout',
    title: 'Abmelden',
    icon: 'fas fa-sign-out-alt',
    path: null,
    action: true
  }
]; 